






































import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import ClickOutside from 'vue-click-outside';
import { GroupByFunctionReturnType, KeywordData } from '@/types';
import { hasSize } from '@/views/promotion/freeGift/conditionList/FreeGiftCondition';

@Component({
  directives: {
    ClickOutside,
  },
})
export default class KeywordWithResultList extends Vue {
  @Prop({ required: true })
  private readonly data: KeywordData[];
  
  @Prop({ default: () => [] })
  private readonly originTargetNos: number[];
  
  @Prop({ default: 'COMMON_INSERT' })
  private readonly placeholder: string;
  
  @Prop({ default: 'keyword' })
  private readonly id?: string;
  
  @Prop({ default: false })
  private readonly disabled: boolean;
  
  public keyword = '';
  private resultList: KeywordData[] = [];
  
  private selectedKeywordsMap: GroupByFunctionReturnType<KeywordData> = new Map();
  private selectedKeywords: KeywordData[] = [];

  @Watch('data')
  private initializeTargetNos() {
    if (!hasSize(this.data)) return;
    if (!hasSize(this.originTargetNos)) return;
    if (this.keyword) return;
    //data 있고 & 수정페이지이면서 지급대상이 있는 경우 & 검색하고 있지 않은 경우
    this.originTargetNos.forEach(this.handleClick);
  }
  
  public reset() {
    this.selectedKeywordsMap = new Map();
    this.resetResultList();
    this.setSelectedKeywords();
  }
  
  public focus() {
    (this.$refs[`${this.id}Ref`] as HTMLInputElement).focus();
  }
  
  private emitSelectedKeywords() {
    this.$emit('selected-keywords', this.selectedKeywords.map(({ no }) => no))
  }
  
  private handleClick(selectedNo: number) {
    const found = this.data.find(({ no }) => no === selectedNo);
    if (!found) return;
    this.setKeyword(found.label);
    this.setSelectedKeywordsMap(found);
    this.resetResultList();
  }
  
  private setKeyword(label: string) {
    this.keyword = label;
  }
  
  private setSelectedKeywordsMap(item: KeywordData) {
    this.selectedKeywordsMap.set(item.no, item);
    this.setSelectedKeywords();
  }
  
  private setSelectedKeywords() {
    this.selectedKeywords = [...this.selectedKeywordsMap.values()];
    this.emitSelectedKeywords();
  }
  
  private resetResultList() {
    this.resultList = [];
    this.keyword = '';
  }
  
  private handleDelete(no: number) {
    if (!this.selectedKeywordsMap.has(no)) return;
    this.selectedKeywordsMap.delete(no);
    this.setSelectedKeywords();
  }
  
  private handleInput({ target }) {
    const keyword = target.value.trim();
    keyword ? this.search() : this.resetResultList();
    this.keyword = keyword;
    this.$emit('handle-input');
  }

  @Watch('data')
  private search() {
    this.resultList = this.data
      .filter(({ label }) => label.includes(this.keyword))
      .map(({ no, label }) => ({ no, label: label.replaceAll(this.keyword, `<span class="blue">${this.keyword}</span>`) }))
  }
}
